module.exports = __webpack_public_path__ + "img/BackgroundRemoval04.7cba5cf8.png";